import { useEffect, useState } from "react";
import ConfigurationScreen from "../screens/configuration/marty/Configuration";
import WifiConfStep1Screen from "../screens/configuration/marty/WifiConfiguration/WifiConfigurationStep1";
import Layout from "../layout/Layout";
import Diagnostics from "../screens/configuration/marty/Diagnostics";
import NavLayout from "../layout/NavLayout";
import Addons from "../screens/configuration/marty/Addons";
import CalibrationNavigator from "./CalibrationNavigator";
import WifiConfStep1aScreen from "../screens/configuration/marty/WifiConfiguration/WifiConfigurationStep1a";
import WifiConfStep2Screen from "../screens/configuration/marty/WifiConfiguration/WifiConfigurationStep2";
import WifiConfStepFailedToConnect from "../screens/configuration/marty/WifiConfiguration/WifiConfigurationStepFailedToConnect";
import WifiConfStepConnected from "../screens/configuration/marty/WifiConfiguration/WifiConfigurationStepConnected";
import { RaftTypeE } from "../types/raft";
import { ConnectedRaftItem } from "../store/SelectedRaftContext";
import { ReactComponent as CogSVG } from "../assets/connect-button/cog_selected.svg";
import { useTranslation } from "react-i18next";

type ScreenType =
  | "configuration"
  | "wifi-configuration-step-1"
  | "wifi-configuration-step-1a"
  | "wifi-configuration-step-2"
  | "wifi-configuration-step-failed-to-connect"
  | "wifi-configuration-step-connected"
  | "diagnostics"
  | "addons"
  | "calibration";

export interface ConfigurationComponentType {
  currentScreenSetter: (screen: ScreenType, params?: any) => void;
}

type Props = {
  connectedRaft: ConnectedRaftItem;
}

export default function ConfigurationNavigator({ connectedRaft }: Props) {

  if (connectedRaft.type === RaftTypeE.MARTY) {
    return <MartyConfigurationNavigator connectedRaft={connectedRaft} />;

  } else if (connectedRaft.type === RaftTypeE.COG) {
    return <CogConfigurationNavigator connectedRaft={connectedRaft} />;
  } else {
    return <div>Unsupported Raft type</div>;
  }
}

function MartyConfigurationNavigator({ connectedRaft }: Props) {
  const [currentScreen, setCurrentScreen] = useState<{
    screen: ScreenType;
    params: any;
  }>({ screen: "configuration", params: {} });

  const currentScreenSetter = (screen: ScreenType, params?: any) => {
    setCurrentScreen({ screen, params });
  };

  let currentScreenJSX;
  switch (currentScreen.screen) {
    case "wifi-configuration-step-1":
      currentScreenJSX = (
        <NavLayout
          onClickBack={() =>
            setCurrentScreen({ screen: "configuration", params: {} })
          }
        >
          <WifiConfStep1Screen currentScreenSetter={currentScreenSetter} />
        </NavLayout>
      );
      break;

    case "wifi-configuration-step-1a":
      currentScreenJSX = (
        <NavLayout
          onClickBack={() =>
            setCurrentScreen({
              screen: "wifi-configuration-step-1",
              params: {},
            })
          }
        >
          <WifiConfStep1aScreen currentScreenSetter={currentScreenSetter} />
        </NavLayout>
      );
      break;

    case "wifi-configuration-step-2":
      currentScreenJSX = (
        <NavLayout
          onClickBack={() =>
            setCurrentScreen({
              screen: "wifi-configuration-step-1",
              params: {},
            })
          }
        >
          <WifiConfStep2Screen
            ssid={currentScreen.params.ssid}
            currentScreenSetter={currentScreenSetter}
            connectedRaft={connectedRaft}
          />
        </NavLayout>
      );
      break;

    case "wifi-configuration-step-failed-to-connect":
      currentScreenJSX = (
        <NavLayout
          onClickBack={() =>
            setCurrentScreen({
              screen: "wifi-configuration-step-1",
              params: {},
            })
          }
        >
          <WifiConfStepFailedToConnect
            ssid={currentScreen.params.ssid}
            currentScreenSetter={currentScreenSetter}
          />
        </NavLayout>
      );
      break;

    case "wifi-configuration-step-connected":
      currentScreenJSX = (
        <NavLayout
          onClickBack={() =>
            setCurrentScreen({
              screen: "configuration",
              params: {},
            })
          }
        >
          <WifiConfStepConnected
            ssid={currentScreen.params.ssid}
            currentScreenSetter={currentScreenSetter}
          />
        </NavLayout>
      );
      break;

    case "diagnostics":
      currentScreenJSX = (
        <NavLayout
          onClickBack={() =>
            setCurrentScreen({ screen: "configuration", params: {} })
          }
        >
          <Diagnostics />
        </NavLayout>
      );
      break;

    case "addons":
      currentScreenJSX = (
        <NavLayout
          onClickBack={() =>
            setCurrentScreen({ screen: "configuration", params: {} })
          }
        >
          <Addons />
        </NavLayout>
      );
      break;

    case "calibration":
      currentScreenJSX = (
        <NavLayout
          onClickBack={() =>
            setCurrentScreen({ screen: "configuration", params: {} })
          }
        >
          <CalibrationNavigator />
        </NavLayout>
      );
      break;

    default:
      currentScreenJSX = (
        <ConfigurationScreen connectedRaft={connectedRaft} currentScreenSetter={currentScreenSetter} key={new Date().toISOString()} />
      );
      break;
  }

  return <Layout>{currentScreenJSX}</Layout>;
}

function CogConfigurationNavigator({ connectedRaft }: Props) {
  const { t } = useTranslation();
  const raft = window.applicationManager.connectedRafts[connectedRaft.id];
  window.applicationManager.toaster.info(t("cog_configuration.not_supported"));
  return <Layout>
    <div style={{
      display: "grid",
      placeItems: "center",
      gridTemplateRows: "min-content min-content",
      height: "100%",
      transform: "translateY(20%)",
    }}>
      <h1 style={{
        marginBottom: "10px"
      }}>{t("cog_configuration.coming_soon")}</h1>
      <CogSVG width={150} height={150} />
      <p style={{
        textAlign: "center",
        maxWidth: "400px"
      }}>{t("cog_configuration.your_cog_version")}: {raft.getRaftVersion()}</p>
    </div>
  </Layout>;
}
